import { render } from "./LoadLocalImage.vue?vue&type=template&id=c0d1e896&scoped=true"
import script from "./LoadLocalImage.vue?vue&type=script&lang=js"
export * from "./LoadLocalImage.vue?vue&type=script&lang=js"

import "./LoadLocalImage.vue?vue&type=style&index=0&id=c0d1e896&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0d1e896"]])

export default __exports__